/**
 * Fixes filenames that were corrupted by multer reading UTF-8 bytes as Latin-1.
 * Example: "KESİNLEŞME" stored as "KESÄ°NLEÅŸME" → correctly decoded back to "KESİNLEŞME"
 *
 * Algorithm:
 *  1. If no chars in U+00C0–U+00FF range → safe ASCII/Unicode, return as-is.
 *  2. Treat each char as a Latin-1 byte, attempt UTF-8 decode with fatal=true.
 *  3. If decode succeeds → return fixed name.
 *  4. If decode throws (bytes aren't valid UTF-8) → name was already correct, return as-is.
 */
export const fixFileName = (name) => {
  if (!name) return name;
  // Quick check: garbled UTF-8-as-Latin1 always produces chars in 0xC0-0xFF range
  if (!/[\xC0-\xFF]/.test(name)) return name;
  try {
    const bytes = new Uint8Array([...name].map((c) => c.charCodeAt(0)));
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return name;
  }
};
